import { Chip } from "@mui/material";
import { STATUS_APURACAO } from "../../constants";

export default function StatusChip({ status }) {
  const cfg = STATUS_APURACAO[status] || STATUS_APURACAO.pendente;
  return (
    <Chip
      label={cfg.label}
      size="small"
      sx={{
        height: 22,
        maxWidth: "9rem",
        fontWeight: "bold",
        bgcolor: cfg.bgcolor,
        color: cfg.color,
        "& .MuiChip-label": {
          px: 0.75,
          fontSize: "0.68rem",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      }}
    />
  );
}
